import { Controller } from "stimulus";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent.js";

/*
 * Points a `load` wrapper at the URL held in the selected option's value, then
 * reloads it - or clears it when that value is blank.
 *
 * The other reload dispatchers (buttons--event, forms--event, views--pager) only
 * vary the query string appended to a wrapper's static `data-url`. Use this one
 * when the *path* itself differs per selection. Option values carry the URL, the
 * same way views--pager#onLimitChange reads its limit select.
 *
 * Writing `data-url` is the point, not a side effect: views--pager reads it back
 * to build its page requests, so the wrapper's `data-url` is the single source of
 * truth for what is currently loaded.
 */
export default class extends Controller {
  static values = { targetId: String };

  // On history navigation the browser restores the select's value without firing change,
  // leaving data-url blank - and Materialize then swallows a re-pick of that same option
  // as "no change", so the table can never load. Same guard as views--checkbox-collection.
  connect() {
    this.element.setAttribute("autocomplete", "off");
  }

  onChange(event) {
    const url = event.target.value;

    this.target.dataset.url = url;

    dispatchCustomEvent(document, `${url ? "reload" : "clear"}-${this.targetIdValue}`);
  }

  get target() {
    return document.getElementById(this.targetIdValue);
  }
}
